<template>
  <table style="width: 100%;">
    <tbody>
      <template v-for="(subTest, index) in itemInput.result.sub_tests">
        <tr :key="`cross-matching-${index}`">
          <td>
            {{ subTest.name }}
          </td>
          <td>
            <template v-if="subTest.input_type === 'dropdown'">
              <b-form-select
                v-model="subTest.value"
                :options="subTest.options"
                value-field="value"
                text-field="name"
              />
            </template>
            <template v-else>
              <b-form-input
                v-model="subTest.value"
                :type="subTest.input_type"
              />
            </template>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
  export default {
    name: "CrossMatching",
    props: {
      test: {}
    },
    computed: {
      itemInput: {
        get() {
          return this.test
        },
        set(val) {
          this.$emit('update:test', val)
        }
      }
    }
  }
</script>

<style scoped>

</style>
